import Grid from '@mui/material/Grid';

import type { HighlightIconCardContent } from '@/components/HighlightIconStat/HighlightIconStat';
import Icon from '@/components/Icon/Icon';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/theme/values/brandColors';

import useStyles from './IconList.styles';

interface TextListProps {
  list: HighlightIconCardContent[] | undefined;
  isOnDark?: boolean | undefined;
}

export default function IconList({ list, isOnDark }: TextListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });

  // biome-ignore lint/correctness/noNestedComponentDefinitions: closes over per-render props
  // biome-ignore lint/correctness/noComponentHookFactories: closes over per-render props
  const IconListItem = ({ item }: { item: HighlightIconCardContent }) => {
    const { icon, cardTitle, subTitle } = item.fields;
    return (
      <Grid
        className={classes.item}
        size={{
          xs: 6,
          sm: 4,
        }}
      >
        <div>
          <Icon
            name={icon.fields.name || ''}
            color={isOnDark ? brandColors.white : brandColors.black}
            width={56}
          />
          <p className={cx(globalClasses.h4, classes.itemHeading)}>
            {cardTitle}
          </p>
          <p className={cx(globalClasses.body, classes.itemBody)}>{subTitle}</p>
        </div>
      </Grid>
    );
  };

  return (
    <GridContainer fixed gridProps={{ className: classes.IconListRow }}>
      {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
      {list &&
        list.map((item, index) => (
          <IconListItem
            key={`icon-list-item-${
              // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
              index
            }`}
            item={item}
          />
        ))}
    </GridContainer>
  );
}
